import colors from '~/styles/colors';

export const taskCategoryColors = [
  { id: 'grey', name: 'Grey', hex: colors.grey55 },
  { id: 'grey-light', name: 'Light Grey', hex: colors.grey20 },
  { id: 'teal', name: 'Teal', hex: colors.primary100 },
  { id: 'teal-light', name: 'Light Teal', hex: colors.primary50 },
  { id: 'blue', name: 'Blue', hex: colors.blue100 },
  { id: 'blue-light', name: 'Light Blue', hex: colors.blue50 },
  { id: 'orange', name: 'Orange', hex: colors.orange100 },
  { id: 'orange-light', name: 'Light Orange', hex: colors.orange50 },
  { id: 'brown', name: 'Brown', hex: colors.brown100 },
  { id: 'brown-light', name: 'Light Brown', hex: colors.brown50 },
  { id: 'purple', name: 'Purple', hex: colors.purple100 },
  { id: 'purple-light', name: 'Light Purple', hex: colors.purple50 },
];

export function getColorHex(colorId) {
  const color = taskCategoryColors.find((c) => c.id === colorId);
  return color?.hex ?? colors.grey55;
}

export default { taskCategoryColors, getColorHex };
